import { MDBContainer } from 'mdb-react-ui-kit';
import Navbar from '../component/navbar';
import Banner from '../component/banner';
import Partners from '../component/partners';
import Services from '../component/services';
import Footer from '../component/footer';
import Vision from '../component/vision';
import Mission from '../component/mission';


export default function Werfen(props) {

    return (
        <MDBContainer fluid className="h-100 w-100 px-0 bg-transparent">
            <Navbar />
            <Banner />
            <Partners />
            <Vision />
            <Mission />
            <Services />
            <Footer />
        </MDBContainer>
    )
}